import React, { useEffect, useState } from 'react';
import IntroSec from '../../Components/PageComponents/IntroSec/IntroSec';
import { SealsSec } from '../../Components/PageComponents/SealsSec/SealsSec';
import UserInfoSec from '../../Components/PageComponents/UserInfoSec/UserInfoSec';
import Repositories from '../../Components/PageComponents/Repositories/Repositories';
import { DiscoverNpos } from '../../Components/PageComponents/DiscoverNpos/DiscoverNpos';
import Philanthropy from '../../Components/PageComponents/PhilanthropySec/Philanthropy';
import CertifiedNpos from '../../Components/PageComponents/CeritfiedNpos/CertifiedNpos';
import NposSectors from '../../Components/PageComponents/NposSectors/NposSectors';
import IssueSec from '../../Components/PageComponents/IssueSec/IssueSec';
import ChangeMakers from '../../Components/PageComponents/ChangeMakers/ChangeMakers';
import CollaboratorsSec from '../../Components/PageComponents/CollaboratorsSec/CollaboratorsSec';
import HeaderSec from '../../Components/HeaderSec/HeaderSec';
import FooterComp from '../../Components/FooterComp/FooterComp';
import FeaturedNpo from '../../Components/PageComponents/NewChangeMakers/FeaturedNpo';
import Opportunities from '../../Components/PageComponents/Opportunities/Opportunities';

export const MainPage = () => {
    return (
        <>
            <div className='homepage'>
                <HeaderSec />
                <section id='intro_sec'>
                    <IntroSec />
                </section>
                <section id='discover_sec'>
                    <DiscoverNpos />
                </section>
                <section id='seal_sec'>
                    <SealsSec />
                </section>
                <section id='opportunities'>
                    <Opportunities />
                </section>
                <section id='repositories_sec'>
                    <Repositories />
                </section>
                <section id='philanthropy_sec'>
                    <Philanthropy />
                </section>
                <section id='certified_sec'>
                    <CertifiedNpos />
                </section>
                <section id='featured_npo'>
                    <FeaturedNpo />
                </section>
                <section id='sectors_sec'>
                    <NposSectors />
                </section>
                <section id='issue_sec'>
                    <IssueSec />
                </section>
                <section id='change_makers_sec'>
                    <ChangeMakers />
                </section>
                <section id='user_info_sec'>
                    <UserInfoSec />
                </section>
                <section id='collaborators_sec'>
                    <CollaboratorsSec />
                </section>
                <FooterComp />
            </div>

        </>
    );
};
